// Zentrale Definition, wann eine Zuordnung "vollständig" ist.
// Feldliste ist mit der Koordination abgestimmt (Abrechnung Jugendamt/Lexware).
export const COMPLETENESS_FIELDS = [
  { key: 'employee_id',   label: 'Mitarbeiter' },
  { key: 'child_name',    label: 'Betreutes Kind' },
  { key: 'school_name',   label: 'Schule' },
  { key: 'weekly_hours',  label: 'Wochenstunden' },
  { key: 'federal_state', label: 'Bundesland' },
  { key: 'jugendamt_id',  label: 'Jugendamt' },
  { key: 'qualifikation', label: 'Qualifikation' },
  { key: 'aktenzeichen',  label: 'Aktenzeichen' },
];

// Auftrag SQ1: Q = Qualifikationsstufe. Aemter mit vier_stufen kennen nur SQ1-SQ4.
export const STUFEN_NORMAL = ['Q1', 'Q2'];
export const STUFEN_VIER = ['SQ1', 'SQ2', 'SQ3', 'SQ4'];
export const erlaubteStufen = (jugendamt) => (jugendamt?.vier_stufen ? STUFEN_VIER : STUFEN_NORMAL);

/** true, wenn die Stufe zum Jugendamt passt (oder das Amt unbekannt ist). */
export function stufePasst(assignment, jugendaemter = []) {
  const ja = jugendaemter.find((j) => j.id === assignment?.jugendamt_id);
  if (!ja) return true;
  return erlaubteStufen(ja).includes(String(assignment?.qualifikation ?? '').trim().toUpperCase());
}

function isFilled(key, value) {
  if (key === 'weekly_hours') {
    // Kommt je nach Herkunft als Zahl (API) oder als String (Formular-State).
    const n = typeof value === 'number' ? value : parseFloat(value);
    return Number.isFinite(n) && n > 0;
  }
  return String(value ?? '').trim().length > 0;
}

/** Labels aller fehlenden Felder, z.B. ['Jugendamt', 'Aktenzeichen']. Leer = vollständig. */
export function getMissingFields(assignment, jugendaemter = []) {
  if (!assignment) return COMPLETENESS_FIELDS.map((f) => f.label);
  return COMPLETENESS_FIELDS
    .filter((f) => isFieldMissing(assignment, f.key, jugendaemter))
    .map((f) => f.label);
}

export function isAssignmentComplete(assignment, jugendaemter = []) {
  return getMissingFields(assignment, jugendaemter).length === 0;
}

/** Für die gezielte Markierung einzelner Zellen und Formularfelder. */
export function isFieldMissing(assignment, key, jugendaemter = []) {
  if (!isFilled(key, assignment?.[key])) return true;
  return key === 'qualifikation' && !stufePasst(assignment, jugendaemter);
}
